import React from "react";
import "./Notification.css";
import * as firebase from 'firebase';
import moment from 'moment';

var firebaseConfig = {
  apiKey: "AIzaSyAZxEY5MJyAgu5Eta8cGk9JxLSvNp9PL5U",
  authDomain: "breeze-b933b.firebaseapp.com",
  databaseURL: "https://breeze-b933b.firebaseio.com",
  projectId: "breeze-b933b",
  storageBucket: "breeze-b933b.appspot.com",
  messagingSenderId: "52860641709",
  appId: "1:52860641709:web:705b28bb0f6946d8008124",
  measurementId: "G-79BZE0QM7K"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);


/** Notification released*/
class Notification extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      toggleNotification: false,
    };
  }

  componentDidMount = () => {
    const firestore = firebase.firestore();
    const user = firebase.auth().currentUser;
    if (user) {
      const db = firestore.collection("Users").doc(user.email);
      if (db.type === "Student") {
        this.setState({ notification: db.notification });
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleOutsideClick, false);
  }


  componentDidUpdate(previousProps) {
    if (previousProps.listItems !== this.props.listItems) {
      this.setState({ listItems: this.props.listItems });
    }
  }

  handleOutsideClick = e => {
    if (!this.node.contains(e.target)) this.toggleNotification();
  };

  toggleNotification = () => {
    if (!this.state.toggleNotification) {
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }

    this.setState({ toggleNotification: !this.state.toggleNotification });
  };


  clearAllMessage = async () => {
    const user = await firebase.auth().currentUser;
    const firestore = await firebase.firestore();
    if (user != null) {
      const db = firestore.collection("Users").doc(user.email);
      const doc = db.get().then((doc) => {
        if (doc.exists) {
          firestore.collection("Users").doc(user.email).update({
            notification: []
          }).then(() => {
            this.props.noFetchData();
          })
        }
      })
    }
  };

  render() {
    return (
      <div>
        <div className={"notification"} ref={node => { this.node = node; }}>
          <div className={"iconSection"}>
            <img
              alt={"Notification"}
              className="navIcons"
              src={process.env.PUBLIC_URL + '/digitalassets/bell.png'}
              onClick={() => { this.toggleNotification() }}
            />
            <span className={"iconBadge"}>{this.props.listItems.length}</span>
          </div>
        </div>

        {this.state.toggleNotification && (
          <div
            style={{
              position: "absolute",
              width: "20em",
              border: "0.5px solid #8080803d",
              borderRadius: "0.8em",
              maxHeight: "20em",
              overflowY: "auto",
              top: "3.5em",
            }}
            className={"notifWindow"}
          >
            <div className="notifWindowHeader">
              <div style={{ fontSize: "25px", textAlign: "left", width: "85%" }}>
                <b>Notifications</b>
              </div>
              <img
                alt={"clear all"}
                style={{ width: "10%", cursor: "pointer" }}
                onClick={() => this.clearAllMessage()}
                src={require("./clearAll.svg")}
              ></img>
            </div>
            <div className="notifList">
              {this.props.listItems.map(({ title, affiliate, location, start, end }) => (
                <div className="notifCard">
                  <strong style={{ color: "var(--BlueFour)", fontSize: "120%" }}>{title}</strong>
                  <small>{"Affiliate: " + affiliate}</small>
                  <small>{"Location: " + location}</small>
                  <small>{"Start: " + moment(start).format("MMM D, YYYY [at] h:mm a")}</small>
                  <small>{"End: " + moment(end).format("MMM D, YYYY [at] h:mm a")}</small>
                </div>))}
            </div>
          </div>)}
      </div>
    );
  }
}

export default Notification;